import { StreamMode } from '../models/StreamMode';

/**
 * Stream Mode text for the AGM details card and map popup (EN-1498).
 *
 * device.lastStreamMode comes from the AGM's last Control Settings response.
 * Streaming is turned on by joining a stream session: the backend queues an
 * SE enable command, and the AGM acks it without sending new Control
 * Settings. So lastStreamMode stays Off while the AGM streams. The backend
 * keeps SE enabled while the UID has an active stream session, so an active
 * session means Cell Stream On.
 */
export function streamModeText(
  lastStreamMode: number | null | undefined,
  activeStreamSessionCount: number | null | undefined
): string {
  if (lastStreamMode === StreamMode.BluetoothStreamOn) {
    return StreamMode.toString(StreamMode.BluetoothStreamOn);
  }
  if ((activeStreamSessionCount ?? 0) > 0) {
    return StreamMode.toString(StreamMode.CellStreamOn);
  }
  if (
    lastStreamMode !== null &&
    lastStreamMode !== undefined &&
    StreamMode.getModes().includes(lastStreamMode)
  ) {
    return StreamMode.toString(lastStreamMode);
  }
  return 'BT/Cell';
}

/**
 * Active stream session count for one UID from the group's session list
 * (streamSession.activeDeviceSessions). The list only holds UIDs with an
 * active session, so a UID whose last viewer left is simply missing: 0.
 */
export function activeStreamSessionCount(
  activeDeviceSessions:
    | { uid: number; activeSessionCount: number }[]
    | null
    | undefined,
  uid: number | null | undefined
): number {
  if (uid === null || uid === undefined || !activeDeviceSessions) return 0;
  const entry = activeDeviceSessions.find((d) => d.uid === uid);
  return entry?.activeSessionCount ?? 0;
}
